import React, { ReactNode } from 'react';

interface Props {
  href: string;
  children: ReactNode;
}

const Breadcrumb = ({ href, children }: Props) => {
  return (
    <p className='text-lg text-abn-brown mb-4'>
      <a href={href}>{children}</a>
    </p>
  );
};

export default Breadcrumb;
